import '../styles/CookiesPopup.scss';

type CookiesPopupProps = {
  onAcceptAll: (e: React.MouseEvent<HTMLElement>) => void;
  onRejectAll: (e: React.MouseEvent<HTMLElement>) => void;
  onOpenSettings: (e: React.MouseEvent<HTMLElement>) => void;
};

const CookiesPopup: React.FC<CookiesPopupProps> = (props) => {
  return (
    <div className="popup-container">
      <h1 className="popup-title">WE USE COOKIES!</h1>
      <p className="popup-text">
        By clicking “Accept all”, you agree to the storing of cookies in your
        device to enhance site navigation, usage analysis and for SoftServe’s
        general marketing purposes.{' '}
        <a
          href="https://www.softserveinc.com/uk-ua/privacy-policy"
          rel="noopener noreferrer"
          target="_blank"
        >
          Cookie policy
        </a>
      </p>
      <div className="btn-container">
        <button className="accept-all" onClick={props.onAcceptAll}>
          Accept all
        </button>
        <div className="white-buttons">
          <button className="reject-all" onClick={props.onRejectAll}>
            Reject all
          </button>
          <button className="settings" onClick={props.onOpenSettings}>
            Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiesPopup;
